module.exports = __webpack_public_path__ + "images/emails/digest/i-arrow-01237d6b.png";